import React from 'react'
import { useNode } from 'react-pagebuilder/hooks/useNode'
import { useEditor } from 'react-pagebuilder/hooks/useEditor'
import { AnchorSection as Original } from 'components/organisms'
import { AnchorSectionSettings } from './AnchorSectionSettings'
import { withBlock } from '../withBlock'
import { withCraft } from '../withCraft'
import { getTextEditor } from '../TextEditor'
import { getItemChildren } from 'react-pagebuilder/utils/node'
import { anchorCardItemParams } from '../AnchorCard'
import {
  layoutDefaultProps,
  layoutItemParams,
} from 'react-pagebuilder/editor/Viewport/Sidebar/Toolbar/LayoutToolbarSection'

export const defaultProps = {
  ...layoutDefaultProps('lg'),
  theme: 'neutral10',
}

export const anchorSectionItemParams = (enabled, id, blockProps, children) => ({
  ...layoutItemParams(blockProps),
  pk: id,
  name: getTextEditor(children?.[0], enabled),
  description: getTextEditor(children?.[1], enabled),
  children: getItemChildren(enabled, children?.[2], anchorCardItemParams),
})

export const dynamicProps = []

export const AnchorSection: any = withBlock(
  (props) => {
    const blockProps = {
      ...defaultProps,
      ...props.block,
    }

    const { children } = props

    const _ = props.renderValue

    const {
      id,
      connectors: { connect },
      selected,
      hovered,
      actions: { setProp, setCustom },
      customs,
    } = useNode(
      (state) => ({
        selected: state.events.selected,
        dragged: state.events.dragged,
        hovered: state.events.hovered,
        customs: state.data.custom,
      }),
      props
    )

    const { enabled } = useEditor(
      (state) => ({
        enabled: state.options.enabled,
      }),
      props
    )

    return (
      <div ref={(ref) => props.retRef(ref)} className={`block-anchor-section ${props.className}`}>
        <Original
          item={anchorSectionItemParams(enabled, id, blockProps, children)}
          theme={blockProps.theme}
          editMode={enabled}
        />
      </div>
    )
  },
  defaultProps,
  dynamicProps
)

AnchorSection.craft = withCraft({
  name: 'AnchorSection',
  defaultProps: defaultProps,
  settings: AnchorSectionSettings,
})
